export default [
  {
    title: "referenties",
    path: "/referenties",
  },
]
